import axios from 'axios';

const SERCH_LIVE_API = '/tv/api/live_search';

export function fetchLive (flg) {
  const onlyLiveFlg = flg === 'banner' ? 1 : 0;
  return axios({
    type: 'GET',
    timeout: 3000,
    crossDomain: true,
    dataType: 'json',
    headers: {
      'X-From': location.href
    },
    url: SERCH_LIVE_API,
    data: {
      only_live: onlyLiveFlg
    }
  }).then(res => {
    return res.data;
  }).catch(err => {
    throw err;
  });
}
